<div class="mt-3">
    <div class="row">
        <div class="col-sm-4 offset-sm-4">
            <br>
            <div class="card">
                <div class="card-body">
                    <h5>Choisir un mot de passe</h5>

                    <p *ngIf="linkValid === null">Vérification du lien…</p>

                    <ng-container *ngIf="linkValid === false">
                        <div class="alert alert-warning">
                            Ce lien n'est plus valide : il a expiré ou a déjà servi.
                        </div>
                        <a routerLink="/forgotten_password" class="btn btn-primary btn-block">Recevoir un nouveau lien</a>
                    </ng-container>

                    <ng-container *ngIf="success">
                        <div class="alert alert-success">
                            Votre mot de passe a bien été enregistré.
                        </div>
                        <a routerLink="/login" class="btn btn-primary btn-block">Se connecter</a>
                    </ng-container>

                    <form *ngIf="linkValid && !success" [formGroup]="resetPasswordForm" (ngSubmit)="onSubmit()">
                        <div class="form-group">
                            <label for="inputNewPassword1">Nouveau mot de passe</label>
                            <input type="password" class="form-control" formControlName="new_password1"
                                id="inputNewPassword1" autocomplete="new-password">
                            <small class="form-text text-muted">
                                Au moins 8 caractères, pas uniquement des chiffres, et pas un mot de passe trop courant.
                            </small>
                            <small class="text-danger"
                                *ngIf="errors['new_password1']">{{errors['new_password1']}}</small>
                        </div>
                        <div class="form-group">
                            <label for="inputNewPassword2">Confirmez le mot de passe</label>
                            <input type="password" class="form-control" formControlName="new_password2"
                                id="inputNewPassword2" autocomplete="new-password">
                            <small class="text-danger"
                                *ngIf="errors['new_password2']">{{errors['new_password2']}}</small>
                        </div>
                        <div class="alert alert-danger" *ngIf="errors['default']">
                            {{errors['default']}}
                        </div>
                        <button [disabled]="loading" type="submit" class="btn btn-primary btn-block">
                            <span *ngIf="loading" class="button-loader"></span>
                            Valider
                        </button>
                    </form>
                </div>
            </div>
        </div>
    </div>
</div>
